(function(){
  if(window.MatFinishV10)return;
  const cache=new Map();
  function surface(gray){
    if(cache.has(gray))return cache.get(gray);
    const c=document.createElement('canvas');c.width=1600;c.height=1000;
    const x=c.getContext('2d');let seed=28471;
    const rand=()=>{seed=(Math.imul(seed,1664525)+1013904223)>>>0;return seed/4294967296;};
    x.fillStyle=gray?'#777977':'#c4a271';x.fillRect(0,0,1600,1000);
    const palette=gray?['#474b49','#969991','#626762','#b0b0a6','#757b73']:['#80623c','#e2c594','#a38151','#dbc08b','#b28e58'];
    x.lineCap='round';
    for(let i=0;i<110000;i++){
      const px=rand()*1600,py=rand()*1000,a=rand()*Math.PI*2,len=2+rand()*9;
      x.strokeStyle=palette[Math.floor(rand()*palette.length)];x.globalAlpha=.35+rand()*.4;x.lineWidth=.7+rand()*1.8;
      x.beginPath();x.moveTo(px,py);x.quadraticCurveTo(px+Math.cos(a+.7)*len*.6,py+Math.sin(a+.7)*len*.6,px+Math.cos(a)*len,py+Math.sin(a)*len);x.stroke();
    }
    x.globalAlpha=1;
    const light=x.createLinearGradient(0,0,800,1000);light.addColorStop(0,'#ffffff16');light.addColorStop(.5,'#ffffff00');light.addColorStop(1,'#241b1217');x.fillStyle=light;x.fillRect(0,0,1600,1000);
    x.lineWidth=12;x.strokeStyle=gray?'#33383288':'#6a4e2988';x.strokeRect(3,3,1594,994);
    x.lineWidth=3;x.strokeStyle='#fff8df50';x.strokeRect(11,11,1578,978);
    cache.set(gray,c);return c;
  }
  function background(ctx,color){ctx.drawImage(surface(color==='Grau'),0,0,1600,1000);}
  function font(size,style){return style==='script3d'?size+'px MatScript, cursive':style==='retro3d'?size+'px MatRetro, Georgia, serif':'900 '+size+'px Arial, sans-serif';}
  function text(ctx,label,x,y,size,style,color,angle=0,maxWidth=1400){
    ctx.save();ctx.translate(x,y);ctx.rotate(angle*Math.PI/180);ctx.textAlign='center';ctx.textBaseline='middle';
    ctx.font=font(size,style);while(ctx.measureText(label).width>maxWidth&&size>12){size--;ctx.font=font(size,style);}
    const gray=color==='Grau',depth=Math.max(2,size*.045);
    ctx.lineJoin='round';ctx.lineWidth=Math.max(1,size*.012);
    ctx.fillStyle=gray?'#343a36':'#75532f';
    ctx.shadowColor='#21180e45';ctx.shadowBlur=size*.055;ctx.shadowOffsetY=size*.035;
    ctx.fillText(label,depth*.65,depth);ctx.shadowColor='transparent';
    for(let d=depth;d>0;d-=.75)ctx.fillText(label,d*.65,d);
    const face=ctx.createLinearGradient(0,-size*.45,0,size*.45);
    face.addColorStop(0,gray?'#fffdf2':'#454039');face.addColorStop(.45,gray?'#efeee5':'#24211d');face.addColorStop(1,gray?'#cccfc4':'#131410');
    ctx.fillStyle=face;ctx.fillText(label,0,0);
    ctx.strokeStyle=gray?'#fff9e95c':'#fff0cc35';ctx.strokeText(label,0,-.35);ctx.restore();
  }
  function family(ctx,label,color){
    text(ctx,label||'Unsere Familie',790,95,57,'bold3d',color,-4,1250);
    text(ctx,'WILLKOMMEN',800,210,132,'bold3d',color,-4,1400);
    ctx.save();ctx.font=font(52,'bold3d');const a=ctx.measureText('in unserem').width;ctx.font=font(86,'script3d');const b=ctx.measureText('Zuhause').width;ctx.restore();
    text(ctx,'in unserem',800-(b+30)/2,325,52,'bold3d',color,-3,600);
    text(ctx,'Zuhause',800+(a+30)/2,321,86,'script3d',color,-3,570);
  }
  window.MatFinishV10={background,font,text,family};
})();
